import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import * as Menu from '../../components/menu'
import * as Router from '../../router'
import * as CommunityConfig from '../community-config/actions'
import * as Constants from './constants'

export const navigateTo = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<any>,
) => action$.ofType(Constants.CREATE_COMMUNITY_SUCCESS)
  .map((action: any) => Router.push(Menu.ADMIN_COMMUNITIES_URL))

export const getAllCommunities = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<any>,
) => action$.ofType(Constants.CREATE_COMMUNITY_SUCCESS)
  .mapTo(CommunityConfig.fetchCommunities())

export const epic = ReduxObservable.combineEpics(navigateTo, getAllCommunities)



// WEBPACK FOOTER //
// ./src/pages/create-community/epic.ts